<template>
  <div style="margin: 0 24px;">
    <el-form ref="formRef" :model="userForm" label-width="auto" label-position="right">
      <el-form-item label="账号：">
        <el-input v-model="userForm.account" placeholder="请输入账号" />
      </el-form-item>
      <el-form-item label="密码：">
        <el-input v-model="pwd" placeholder="请输入密码" />
        <p style="font-size: 12px; color: #ff5555; margin-bottom: -12px">* 密码必须包含大写字母、小写字母和数字</p>
      </el-form-item>
      <el-form-item label="名称：">
        <el-input v-model="userForm.name" placeholder="请输入姓名" />
      </el-form-item>
      <div style="text-align: center;margin: 24px 0 16px;">以下信息项的每天查看次数</div>
      <el-form-item label="手机号：">
        <el-input type="text" v-model="phoneViewNum" placeholder="请输入手机号查看次数"></el-input>
      </el-form-item>
      <el-form-item label="身份证号：">
        <el-input type="text" v-model="idnoViewNum" placeholder="请输入身份证号查看次数"></el-input>
      </el-form-item>
      <el-form-item label="微信：">
        <el-input type="text" v-model="wechatViewNum" placeholder="请输入微信查看次数"></el-input>
      </el-form-item>
      <el-form-item label="身份证图：">
        <el-input type="text" v-model="idnoImgViewNum" placeholder="请输入身份证图查看次数"></el-input>
      </el-form-item>
      <el-space :size="16">
<!--        <div><label>超级管理员：</label><el-switch v-model="isSuper" /></div>-->
        <div><label>停用账号：</label><el-switch v-model="state" /></div>
      </el-space>
    </el-form>
    <div class="dialog-footer">
      <el-button @click.native="cancel" >取消</el-button>
      <el-button type="primary" @click="summit">确定</el-button>
    </div>
  </div>

</template>

<script>
import { postJson } from "@/api/api"
import { addOrUpdateUser } from "@/api/url";

export default {
name: "UserFromDialog",
  props: {
    value: Object
  },
  data() {
   return {
     userForm: this.value.userForm,
     idx: this.value.ids,
     pwd: '',
     isSuper: this.value.userForm.isSuper == 1?true: false,
     state: this.value.userForm.state == 1?true:false,
     phoneViewNum: this.value.userForm.phoneViewNum?this.value.userForm.phoneViewNum:100,
     idnoViewNum: this.value.userForm.idnoViewNum?this.value.userForm.idnoViewNum:100,
     wechatViewNum: this.value.userForm.wechatViewNum?this.value.userForm.wechatViewNum:100,
     idnoImgViewNum: this.value.userForm.idnoImgViewNum?this.value.userForm.idnoImgViewNum:100,
   }
  },
  methods: {
    cancel() {
      this.$emit("close");
    },
    summit() {
      console.log(this.idx)
      if(!this.userForm.account) {
        this.$message({
          showClose: true,
          duration: 2000,
          message: '账号不能为空',
          type: 'warning'
        });
        return false
      }
      if(this.idx == -1 && !this.pwd) {
        this.$message({
          showClose: true,
          duration: 2000,
          message: '密码不能为空',
          type: 'warning'
        });
        return false
      }
      if(!this.userForm.name) {
        this.$message({
          showClose: true,
          duration: 2000,
          message: '名称不能为空',
          type: 'warning'
        });
        return false
      }
      let param = {}

      param['id'] = this.idx > -1?this.userForm.id:0;
      param['account'] = this.userForm.account;
      param['psw'] = this.pwd;
      param['name'] = this.userForm.name;
      param['sysModelIds'] = this.idx > -1?this.userForm.sysModelIds:'';
      param['duration'] = this.idx > -1?this.userForm.duration:0;
      param['isSuper'] = this.isSuper?1:0;
      param['state'] = this.state?1:0;
      param['phoneViewNum'] = this.phoneViewNum;
      param['idnoViewNum'] = this.idnoViewNum;
      param['wechatViewNum'] = this.wechatViewNum;
      param['idnoImgViewNum'] = this.idnoImgViewNum;
      postJson(addOrUpdateUser, param).then((data) => {
        let {msg, code} = data
        if (code == 200) {
          this.$message({
            showClose: true,
            duration: 2000,
            message: msg,
            type: 'success'
          });
          this.$emit('confirm', param)
        }else {
          this.$message({
            showClose: true,
            duration: 2000,
            message: msg,
            type: 'warning'
          });
        }
      })
    }
  }
}
</script>

<style scoped>

</style>
